var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUndrawBulk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.121,
    height: 496.784,
    viewBox: "0 0 800.121 496.784",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-234.114 -209.828)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(234.114 211.582)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 434.266,
    height: 244.178,
    rx: 6,
    transform: "translate(0 0)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 424.961,
    height: 234.876,
    rx: 3,
    transform: "translate(4.653 4.652)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(54.166 122.089)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.742,190.45H502.006a8.393,8.393,0,0,1-8.3-7.214,186.792,186.792,0,0,1,0-50.306,8.393,8.393,0,0,1,8.162-7.213c11.559-5.181,24.005-5.18,37,0a8.3,8.3,0,0,1,6.312,3.044,8.487,8.487,0,0,1,1.751,7.073,112.933,112.933,0,0,0,0,44.5,8.486,8.486,0,0,1-1.751,7.074A8.294,8.294,0,0,1,538.742,190.45Z",
    transform: "translate(-492.002 -121.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,152.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -114.076)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,164.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -116.546)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083,0A5.083,5.083,0,1,1,0,5.083,5.083,5.083,0,0,1,5.083,0Z",
    transform: "translate(22.465 11.642)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,164.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -107.016)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(127.585 38.747)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.742,190.45H502.006a8.393,8.393,0,0,1-8.3-7.214,186.792,186.792,0,0,1,0-50.306,8.393,8.393,0,0,1,8.162-7.213c11.559-5.181,24.005-5.18,37,0a8.3,8.3,0,0,1,6.312,3.044,8.487,8.487,0,0,1,1.751,7.073,112.933,112.933,0,0,0,0,44.5,8.486,8.486,0,0,1-1.751,7.074A8.294,8.294,0,0,1,538.742,190.45Z",
    transform: "translate(-492.002 -121.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,152.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -114.076)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,164.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -116.546)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083,0A5.083,5.083,0,1,1,0,5.083,5.083,5.083,0,0,1,5.083,0Z",
    transform: "translate(22.465 11.642)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,164.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -107.016)",
    fill: "#090814"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(237.044 156.398)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M538.742,190.45H502.006a8.393,8.393,0,0,1-8.3-7.214,186.792,186.792,0,0,1,0-50.306,8.393,8.393,0,0,1,8.162-7.213c11.559-5.181,24.005-5.18,37,0a8.3,8.3,0,0,1,6.312,3.044,8.487,8.487,0,0,1,1.751,7.073,112.933,112.933,0,0,0,0,44.5,8.486,8.486,0,0,1-1.751,7.074A8.294,8.294,0,0,1,538.742,190.45Z",
    transform: "translate(-492.002 -121.831)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,152.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -114.076)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,164.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -116.546)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.083,0A5.083,5.083,0,1,1,0,5.083,5.083,5.083,0,0,1,5.083,0Z",
    transform: "translate(22.465 11.642)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.646,164.6H501.723a1.933,1.933,0,0,1,0-3.865h30.924a1.933,1.933,0,0,1,0,3.865Z",
    transform: "translate(-489.753 -107.016)",
    fill: "#090814"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.819, 0.574, -0.574, 0.819, 596.545, 281.532)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.5,81.483H11.88A9.966,9.966,0,0,1,2.02,72.916a221.811,221.811,0,0,1,0-59.737,9.966,9.966,0,0,1,9.692-8.566c13.726-6.152,28.506-6.151,43.941,0a9.851,9.851,0,0,1,7.5,3.615,10.077,10.077,0,0,1,2.079,8.4,134.108,134.108,0,0,0,0,52.839,10.077,10.077,0,0,1-2.079,8.4A9.849,9.849,0,0,1,55.5,81.483Z",
    transform: "translate(0 0)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.016,4.59H2.295a2.295,2.295,0,0,1,0-4.59H39.016a2.295,2.295,0,0,1,0,4.59Z",
    transform: "translate(11.918 41.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.016,4.59H2.295a2.295,2.295,0,0,1,0-4.59H39.016a2.295,2.295,0,0,1,0,4.59Z",
    transform: "translate(11.918 52.477)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.016,4.59H2.295a2.295,2.295,0,0,1,0-4.59H39.016a2.295,2.295,0,0,1,0,4.59Z",
    transform: "translate(11.918 63.793)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(603.742 209.828)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M364.141,239.583,398.022,355.4a25.4,25.4,0,0,1-22.159,32.428l-36.972,3.236,25.249-151.482Z",
    transform: "translate(-29.906 -81.803)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.141,239.583,398.022,355.4a25.4,25.4,0,0,1-22.159,32.428l-36.972,3.236,25.249-151.482Z",
    transform: "translate(-29.906 -81.803)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M784.363,178.443l45.32,74.951,21.339-27.034-41.7-65.292c1.482-7.6-.312-16.413-5.614-24.027-9.277-13.323-25.735-17.9-36.761-10.222s-12.444,24.7-3.167,38.024C769.078,172.456,776.725,177.2,784.363,178.443Z",
    transform: "translate(-757.649 -42.029)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.949,483.036l5.442,18.509-.185,18.768s35.8,43.053,22.608,136.175l-167.721-2.1,19.979-149.845,119.876-21.5Z",
    transform: "translate(-213.692 -164.927)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.63,68.9a47.563,47.563,0,1,0-61.813,45.389L498.908,120l-12.731,44.559,14.835,10.494,46.874-39.062s-10.126-12.9-15.557-27.442A47.512,47.512,0,0,0,553.63,68.9Z",
    transform: "translate(-263.251 -7.285)",
    fill: "#9f616a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.424,199.579c16.793-.256,47.835,53.634,47.835,53.634l25.5-9.018L538.2,225.628,578.4,209.086l-.177,1.215c.158-.381.33-.766.52-1.154,4.226-8.707,16.5-18.951,51.347-16.921L646.5,205.177l2.232,1.774a50.608,50.608,0,0,1,20.671,3.22c7.463,3,14.927,8.6,18.457,19.061,1.829,5.4,1.829,16.555.732,30.731-3.97,51.329-22.47,160.447-22.47,160.447L549.325,404.949l-8.616.2s-1.024-11.762-1.939-27.164c-.567-9.037-1.079-19.3-1.372-29.177-.2-7.244-.256-14.268-.128-20.451.018-.384.018-.769.037-1.153.348-11.286,1.482-19.463,3.915-20.359,0,0-7.555-.2-18.457-.6-26.341-.988-72.256-3.2-78.8-6.768-9.256-5.031-57.786-72.548-57.786-72.548s9.439-27.073,26.25-27.347Z",
    transform: "translate(-351.323 -65.544)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.021,65.125c3.593-17.578,5.316-26.582,18.376-39.016,3.1.439-.818,16.511,16.268,38.9,24.837,32.547,22.361,2.705,29.706,12.731,1.594,2.177,1.939,10.029,1.415,12.731-2.07,10.675-14.323.252-1.415,36.779,1.921,2.841,4.185,2.15,7.073,2.122.224,0-1.241-.282,4.244-1.415,2.618-.541,6.282-1.179,10.675-1.919,51.031-8.6,69.05-72.988,29.606-106.487-8.974-7.622-17.782-13.4-25.428-16.075-23.031-8.062-75.507-2.822-85.581,23.34A80.127,80.127,0,0,0,397.021,65.125Z",
    transform: "translate(-203.174 0)",
    fill: "#010102"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 31.043,
    cy: 31.043,
    rx: 31.043,
    ry: 31.043,
    transform: "translate(262.267 105.684)",
    fill: "#010102"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.766,750.885H403.78c1.038-.131,1.8-1.627,1.737-3.347.067-1.7-.7-3.2-1.737-3.329H1.766c-.914.186-1.636,1.384-1.748,2.9C-.129,748.959.649,750.641,1.766,750.885Z",
    transform: "translate(24.972 -254.102)",
    fill: "#f2f2f2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndrawBulk);
export default __webpack_public_path__ + "static/media/undraw_bulk.c5f93cc55bb62db82283e0b342394951.svg";
export { ForwardRef as ReactComponent };